export const ADDWEBINFO = "WebInfo/Add";
